export default __webpack_public_path__ + "static/media/susesi4.c3806b19.jpg";